<script>
    import { business, loading, showPopup } from "../stores.js";
    import { pop } from "svelte-spa-router";
    import * as BusinessDAL from "../dal/business-dal";
    import * as UserDAL from "../dal/user-dal";

    let hours = [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23,
    ];

    let days = [0, 1, 2, 3, 4, 5, 6];

    let schedule = {};
    days.forEach((day) => {
        schedule[day] = {
            from: 0,
            to: 0,
            open: true,
        };
    });

    function dayToLetter(num) {
        switch (num) {
            case 0:
                return "א";
            case 1:
                return "ב";
            case 2:
                return "ג";
            case 3:
                return "ד";
            case 4:
                return "ה";
            case 5:
                return "ו";
            case 6:
                return "ש";
        }
    }

    async function save() {
        showPopup("האם אתה בטוח?", async () => {
            try {
                $loading = true;
                let businessCode = $business.code;
                loading.set(true);
                await BusinessDAL.setBusinessHours(businessCode, schedule);
                $loading = false;
                pop();
            } catch (e) {
                $loading = false;
                UserDAL.sendLog("setOutOfStock", e.toString());
                showPopup("משהו השתבש", () => {});
            }
        });
    }

    business.subscribe((b) => {
        if (b?.schedule) {
            schedule = b.schedule;
        }
    });

</script>

<div class="overlay" on:click={pop}>
    <div class="container">
        <div class="bg" on:click|stopPropagation>
            <div class="title">שעות פתיחה</div>
            <div class="select">
                {#each days as day}
                    <div class="day">
                        <input
                            type="checkbox"
                            bind:checked={schedule[day].open}
                        />
                        <div
                            class="details"
                            class:disabled={!schedule[day].open}
                        >
                            <span>{dayToLetter(day)}'</span>
                            <select
                                name="from"
                                id="from"
                                bind:value={schedule[day].from}
                            >
                                {#each hours as hour}
                                    <option value={hour}>
                                        {hour > 9 ? +hour + ':00' : '0' + hour + ':00'}
                                    </option>
                                {/each}
                            </select>
                            <span>עד-</span>
                            <select
                                name="from"
                                id="from"
                                bind:value={schedule[day].to}
                            >
                                {#each hours as hour}
                                    <option value={hour}>
                                        {hour > 9 ? +hour + ':00' : '0' + hour + ':00'}
                                    </option>
                                {/each}
                            </select>
                        </div>
                    </div>
                {/each}
            </div>
            <div class="btns">
                <div class="save" on:click={save}>שמירה</div>
            </div>
        </div>
    </div>
</div>

<style>
    .overlay {
        position: fixed;
        background: #0004;
        width: 100%;
        height: 100%;
        padding: 10px;
        box-sizing: border-box;
        z-index: 2;
        display: block;
        justify-content: center;
        padding-top: var(--nav-bar-height);
        margin-bottom: 30px;
        top: 0;
        overflow: auto;
    }

    .container {
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .bg {
        width: 100%;
        max-width: 560px;
        background: white;
        direction: rtl;
        padding: 18px;
        border-radius: 3px;
        box-shadow: 0 20px 25px -20px;
        box-sizing: border-box;
        margin-left: auto;
        margin-right: auto;
    }

    .title {
        font-size: 20px;
        margin: 20px;
    }
    select {
        min-width: 80px;
        border-radius: 4px;
        padding: 4px;
        margin-left: 15px;
        margin: 6px;
    }

    .select {
        margin: 20px;
        font-size: 1.5rem;
        display: flex;
        flex-direction: column;
    }

    .save {
        width: 100%;
        background: var(--green1);
        color: white;
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        font-size: 20px;
        padding: 10px;
        margin-top: 40px;
        border-radius: 3px;
        cursor: pointer;
    }

    .disabled {
        opacity: 0.3;
        pointer-events: none;
    }
    @media screen and (max-width: 560px) {
        .overlay {
            padding: 0;
            padding-top: 30px;
        }
    }

    .day {
        display: flex;
        align-items: center;
    }

    .day > .details {
        display: grid;
        align-items: center;
        grid-template-columns: 0.2fr 2fr 0.2fr 2fr;
        grid-template-rows: 1fr;
        width: 100%;
    }

    .day > input[type="checkbox"] {
        margin-left: 10px;
        margin-bottom: 0;
    }

</style>
